import AccidentTravailTauxPatronal from '@/generated/controls/accidentTravail/AccidentTravailTauxPatronal.vue';
import { defineComponent } from "vue";
import {GenControl, RessourceGenControl} from "@/generated/ressources/generatedRessources.ts";
import {EditFieldType, FieldInfo, getFormat} from "@/framework/base/components/FieldInfo.ts";

export default defineComponent({
    components: {},
    extends: AccidentTravailTauxPatronal,
    computed: {
        ressource () { return RessourceGenControl(GenControl.ACCIDENT_TRAVAIL_TAUX_PATRONAL); },
        editFieldInfo (): FieldInfo {
            const type = EditFieldType.PERCENTAGE;
            const precision = 2;
            const format = getFormat('');
            const focus = this.focusValidator;
            const live = this.liveValidator;
            const mask = this.mask;
            return new FieldInfo(this.ressource, type, precision, mask, format, focus, live, this.theme);
        }
    },
})
